import Translator from '../../classes/Translator/Translator';

const Slide3Logic = () => {
  const { translator } = Translator();

  return {
    translator,
  };
};

export default Slide3Logic;
